module.exports = __webpack_public_path__ + "static/img/code2.5d1fe49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code2.jpg
// module id = 40GY
// module chunks = 56